// start:ng42.barrel
export * from './confirmation.component';
// end:ng42.barrel
